export type OwnerCategoryId =
  | "party"
  | "drinking"
  | "couples";

export type OwnerGameId =
  | "truth-or-dare"
  | "spotlight"
  | "secret-answer"
  | "called-out"
  | "high-or-low"
  | "kings-cup";

export interface OwnerGameCategory {
  readonly id:
    OwnerCategoryId;

  readonly title:
    string;

  readonly shortTitle:
    string;

  readonly description:
    string;

  readonly artwork:
    string;
}

export interface OwnerCatalogueGame {
  readonly id:
    OwnerGameId;

  readonly categoryId:
    OwnerCategoryId;

  readonly title:
    string;

  readonly eyebrow:
    string;

  readonly description:
    string;

  readonly meta:
    string;

  readonly monogram:
    string;

  readonly availability:
    | "AVAILABLE"
    | "COMING_SOON";

  readonly artwork:
    string;
}

export const OWNER_GAME_CATEGORIES:
readonly OwnerGameCategory[] = [
  {
    id:
      "party",

    title:
      "Party Games",

    shortTitle:
      "Party",

    description:
      "Chaos, confessions and the stories you'll hear about tomorrow.",

    artwork:
      "/assets/categories/party/catalogue.png",
  },

  {
    id:
      "drinking",

    title:
      "Drinking Games",

    shortTitle:
      "Drinking",

    description:
      "Cards, calls and questionable decisions.",

    artwork:
      "/assets/categories/drinking/catalogue.png",
  },

  {
    id:
      "couples",

    title:
      "Couples Games",

    shortTitle:
      "Couples",

    description:
      "Made for two. A completely separate side of the night.",

    artwork:
      "/assets/categories/couples/catalogue.png",
  },
];

export const OWNER_GAME_CATALOGUE:
readonly OwnerCatalogueGame[] = [
  {
    id:
      "truth-or-dare",

    categoryId:
      "party",

    title:
      "Truth or Dare",

    eyebrow:
      "PARTY GAME",

    description:
      "Choose your fate. Answer honestly or prove you're brave enough.",

    meta:
      "2–20 players · EN / NL",

    monogram:
      "T/D",

    availability:
      "AVAILABLE",

    artwork:
      "/assets/games/truth-or-dare/catalogue.png",
  },

  {
    id:
      "spotlight",

    categoryId:
      "party",

    title:
      "Spotlight",

    eyebrow:
      "PARTY GAME",

    description:
      "Act it. Sell it. Own the room before the clock wins.",

    meta:
      "Quickfire · Teams · Solo",

    monogram:
      "SP",

    availability:
      "COMING_SOON",

    artwork:
      "/assets/games/spotlight/catalogue.png",
  },

  {
    id:
      "secret-answer",

    categoryId:
      "party",

    title:
      "Secret Answer",

    eyebrow:
      "PARTY GAME",

    description:
      "How well do you really know the person sitting next to you?",

    meta:
      "Prediction · Reveal",

    monogram:
      "SA",

    availability:
      "COMING_SOON",

    artwork:
      "/assets/games/secret-answer/catalogue.png",
  },

  {
    id:
      "called-out",

    categoryId:
      "party",

    title:
      "Called Out",

    eyebrow:
      "PARTY GAME",

    description:
      "Everyone votes. Someone gets exposed.",

    meta:
      "Secret voting · 3+",

    monogram:
      "CO",

    availability:
      "COMING_SOON",

    artwork:
      "/assets/games/called-out/catalogue.png",
  },

  {
    id:
      "high-or-low",

    categoryId:
      "drinking",

    title:
      "High or Low",

    eyebrow:
      "DRINKING GAME",

    description:
      "Six phases. One deck. Increasingly bad confidence.",

    meta:
      "6 phases · 2+ players",

    monogram:
      "H/L",

    availability:
      "AVAILABLE",

    artwork:
      "/assets/games/high-or-low/catalogue.png",
  },

  {
    id:
      "kings-cup",

    categoryId:
      "drinking",

    title:
      "King's Cup",

    eyebrow:
      "DRINKING GAME",

    description:
      "The classic party deck, rebuilt for CUE THE NIGHT.",

    meta:
      "188 variants · EN / NL",

    monogram:
      "KC",

    availability:
      "COMING_SOON",

    artwork:
      "/assets/games/kings-cup/catalogue.png",
  },
];

export function ownerGamesForCategory(
  categoryId:
    OwnerCategoryId,
): readonly OwnerCatalogueGame[] {
  return OWNER_GAME_CATALOGUE.filter(
    (game) =>
      game.categoryId ===
      categoryId,
  );
}